import { Component } from "react";

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error("ErrorBoundary caught:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-[50vh] gap-8 text-pine px-12">
                    <h2 className="text-3xl font-bold font-robotoCondensed">
                        Something went wrong
                    </h2>
                    <p className="text-lg text-center max-w-md">
                        An unexpected error occurred. Please refresh the page to
                        try again.
                    </p>
                    <button
                        className="px-8 py-3 bg-pine text-white rounded-full font-semibold hover:bg-[#313D38] transition-colors"
                        onClick={() => window.location.reload()}
                    >
                        Refresh page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
